import React from 'react';
import IntroExampleContainer from 'containers/IntroExampleContainer/IntroExampleContainer';

export default function IntroExamplePage() {
    return (
        <IntroExampleContainer />
    )
}
